import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnShowHideComponent } from './dn-show-hide.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DnShowHideComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [DnShowHideComponent],
})
export class DnShowHideModule {}
